import React from 'react';
import Button from '../common/Button.js';

const BranchList = ({
  branches,
  loading,
  error,
  onCreateBranch,
  onEditBranch,
  onViewDetails,
  onToggleStatus
}) => {
  if (loading) {
    return (
      <div className="overflow-auto h-[400px]">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50 text-left text-gray-600">
            <tr>
              <th className="px-4 py-3 font-medium">Name</th>
              <th className="px-4 py-3 font-medium">Location</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="4" className="px-4 py-8 text-center text-gray-500">
                Loading branches...
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  if (branches.length === 0) {
    return (
      <div className="overflow-auto h-[400px]">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50 text-left text-gray-600">
            <tr>
              <th className="px-4 py-3 font-medium">Name</th>
              <th className="px-4 py-3 font-medium">Location</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="4" className="px-4 py-8 text-center text-gray-500">
                No branches available.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="overflow-auto h-[400px]">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50 text-left text-gray-600">
          <tr>
            <th className="px-4 py-3 font-medium">Name</th>
            <th className="px-4 py-3 font-medium">Location</th>
            <th className="px-4 py-3 font-medium">Status</th>
            <th className="px-4 py-3 font-medium">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {branches.map((branch) => (
            <tr key={branch.id} className="hover:bg-gray-50">
              <td className="px-4 py-4 font-medium text-slate-900">{branch.name}</td>
              <td className="px-4 py-4 text-gray-600">{branch.location}</td>
              <td className="px-4 py-4">
                <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${
                  branch.state === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'
                }`}>
                  {branch.state}
                </span>
              </td>
              <td className="px-4 py-4 space-x-2 flex">
                <Button
                  size="small"
                  variant="outline"
                  onClick={() => onViewDetails(branch)}
                >
                  View
                </Button>
                <Button
                  size="small"
                  variant="outline"
                  onClick={() => onEditBranch(branch)}
                >
                  Edit
                </Button>
                <Button
                  size="small"
                  variant={branch.state === 'Active' ? 'danger' : 'secondary'}
                  onClick={() => onToggleStatus(branch)}
                >
                  {branch.state === 'Active' ? 'Deactivate' : 'Activate'}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BranchList;